var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadWhiteAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.16797 13.1667L9.5013 16.5M9.5013 16.5L12.8346 13.1667M9.5013 16.5V9M16.168 12.9524C17.1859 12.1117 17.8346 10.8399 17.8346 9.41667C17.8346 6.88536 15.7826 4.83333 13.2513 4.83333C13.0692 4.83333 12.8989 4.73833 12.8064 4.58145C11.7197 2.73736 9.71333 1.5 7.41797 1.5C3.96619 1.5 1.16797 4.29822 1.16797 7.75C1.16797 9.47175 1.86417 11.0309 2.99043 12.1613",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadWhiteAlt);
export default __webpack_public_path__ + "static/media/download-white-alt.a2923529dc59c9e544ab3c22fe8b5fbf.svg";
export { ForwardRef as ReactComponent };